import { render, staticRenderFns } from "./BusquedaArticuloComponent.vue?vue&type=template&id=2154f70b&scoped=true"
import script from "./BusquedaArticuloComponent.vue?vue&type=script&lang=js"
export * from "./BusquedaArticuloComponent.vue?vue&type=script&lang=js"
import style0 from "./BusquedaArticuloComponent.vue?vue&type=style&index=0&id=2154f70b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154f70b",
  null
  
)

export default component.exports